import * as _ from "lodash";
import {BaseBrandedViewOptions, BaseView} from "./_BaseViews";

interface AuthMigrateViewOptions extends BaseBrandedViewOptions {
    userId: number;
    token: string;
}

export class AuthMigrateView extends BaseView {
    options: AuthMigrateViewOptions;
    template = _.template(require('templates/authMigrate.html'));

    constructor(options: AuthMigrateViewOptions) {
        super({tagName: 'div',});
        this.options = options;
    };

    render() {
        this.$el.html(this.template(this.options));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/AuthMigrateView.ts